import React, { useEffect, useRef, useState } from "react";
import Brand from "./Brand";
import { navLinks } from "../data/content";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState(null);
  const navRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close the dropdown when clicking outside it or pressing Escape
  useEffect(() => {
    const onClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) setDropdown(null);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setDropdown(null);
    };
    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("click", onClick);
      document.removeEventListener("keydown", onKey);
    };
  }, []);

  const close = () => {
    setOpen(false);
    setDropdown(null);
  };

  return (
    <header className={`site-nav ${scrolled ? "is-scrolled" : ""} ${open ? "is-open" : ""}`}>
      <div className="container site-nav-inner">
        <a href="#top" className="site-nav-brand" aria-label="MN2GROW home" onClick={close}>
          <Brand />
        </a>

        <button
          className="nav-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="primary-nav"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"}`} aria-hidden="true" />
        </button>

        <nav id="primary-nav" className="site-nav-links" aria-label="Primary" ref={navRef}>
          {navLinks.map((l) =>
            l.children ? (
              <div
                key={l.label}
                className={`nav-dropdown ${dropdown === l.label ? "is-open" : ""}`}
              >
                <button
                  type="button"
                  className="nav-dropdown-toggle"
                  aria-expanded={dropdown === l.label}
                  aria-controls={`menu-${l.label}`}
                  onClick={() => setDropdown((d) => (d === l.label ? null : l.label))}
                >
                  {l.label}
                  <i className="fa-solid fa-chevron-down nav-caret" aria-hidden="true" />
                </button>
                <div id={`menu-${l.label}`} className="nav-dropdown-menu">
                  {l.children.map((c) => (
                    <a
                      key={c.label}
                      href={c.href}
                      onClick={close}
                      {...(c.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <span className="nav-dropdown-label">
                        {c.label}
                        {c.external && (
                          <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true" />
                        )}
                      </span>
                      {c.desc && <small>{c.desc}</small>}
                    </a>
                  ))}
                </div>
              </div>
            ) : (
              <a key={l.href} href={l.href} onClick={close}>
                {l.label}
              </a>
            )
          )}
          <a href="#contact" className="btn-corp btn-corp-primary nav-cta" onClick={close}>
            Request a consultation
          </a>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
